import { ApolloQueryResult, FetchResult } from '@apollo/client';
import * as queryTypes from './graphqlTypes';
import rootSetters from '../actions';
import rootGetters from '../getters';
import * as lodash from 'lodash';
import { defaultSearchFilter } from '../product/utils';

export const findUser =
  () => (dispatch: DispatchType, getState: GetStateType) =>
    new Promise<ApolloQueryResult<FindOneUserQuery>>((resolve, reject) => {
      const {
        auth: { getSubject },
      } = rootGetters(getState());
      const {
        invoice: { filterUserGroups },
        graphql: { QUERY },
        user: { setCurrentUser },
      } = rootSetters(dispatch);
      QUERY<FindOneUserQuery>({
        query: queryTypes.FIND_ONE_USER,
        variables: { userId: getSubject() },
      })
        .then((result) => {
          setCurrentUser(result.data.findUser);
          filterUserGroups();
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });

export const recoverPassword =
  () => (dispatch: DispatchType, getState: GetStateType) =>
    new Promise<
      FetchResult<
        RecoverPasswordMutation,
        Record<string, any>,
        Record<string, any>
      >
    >((resolve, reject) => {
      const {
        form: { getForm },
      } = rootGetters(getState());
      const {
        graphql: { MUTATE },
      } = rootSetters(dispatch);

      const email = getForm('recoverPassword.email');
      MUTATE<RecoverPasswordMutation>({
        mutation: queryTypes.RECOVER_PASSWORD,
        variables: {
          recoverPasswordInput: {
            email,
          },
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });

export const updateUserPassword =
  () => (dispatch: DispatchType, getState: GetStateType) =>
    new Promise<
      FetchResult<
        UpdateUserPasswordMutation,
        Record<string, any>,
        Record<string, any>
      >
    >((resolve, reject) => {
      const {
        form: { getForm },
      } = rootGetters(getState());
      const {
        graphql: { MUTATE },
      } = rootSetters(dispatch);

      const { code, password } = getForm('recoverPassword');

      MUTATE<UpdateUserPasswordMutation>({
        mutation: queryTypes.UPDATE_USER_PASSWORD,
        variables: {
          updateUserPasswordInput: {
            code,
            password,
          },
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });

export const selectFilial =
  (filialId: number) => (dispatch: DispatchType, getState: GetStateType) => {
    const {
      user: { selectedFilialId },
    } = getState();
    if (selectedFilialId === filialId) return;
    const {
      form: { setForm },
      user: { setUser },
      banner: { updateUserSiganature, setBannerConfigs },
      product: { setProduct },
    } = rootSetters(dispatch);

    setUser('selectedFilialId', filialId);

    const {
      form: { getForm },
      banner: { getDefaultBannerForm },
    } = rootGetters(getState());

    updateUserSiganature();
    const form = getForm('banner');
    const defaultForm = getDefaultBannerForm();
    setForm('banner', lodash.merge({}, form, defaultForm));
    setForm(`banner.config.filter.filter`, []);
    setForm(`banner.config.autocompletes.promotion.filter`, []);
    setBannerConfigs();

    setProduct({
      field: 'filters.promotion.filter',
      value: defaultSearchFilter(),
    });
  };

export const filterBranchesQuery =
  (searchFilter: SearchFilter) => (dispatch: DispatchType) =>
    new Promise<ApolloQueryResult<FilterBranchesQuery>>((resolve, reject) => {
      const {
        graphql: { QUERY },
      } = rootSetters(dispatch);
      QUERY<FilterBranchesQuery>({
        query: queryTypes.FILTER_BRANCHES,
        variables: {
          searchFilter,
        },
      })
        .then(resolve)
        .catch(reject);
    });

const userActionCreators = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      selectFilial: (filialId: number) =>
        dispatch<Promise<ApolloQueryResult<FindOneUserQuery>>>(
          selectFilial(filialId),
        ),
      findUser: () =>
        dispatch<Promise<ApolloQueryResult<FindOneUserQuery>>>(findUser()),
      recoverPassword: () =>
        dispatch<
          Promise<
            FetchResult<
              RecoverPasswordMutation,
              Record<string, any>,
              Record<string, any>
            >
          >
        >(recoverPassword()),
      updateUserPassword: () =>
        dispatch<
          Promise<
            FetchResult<
              UpdateUserPasswordMutation,
              Record<string, any>,
              Record<string, any>
            >
          >
        >(updateUserPassword()),
      filterBranchesQuery: (searchFilter: SearchFilter) =>
        dispatch<Promise<ApolloQueryResult<FilterBranchesQuery>>>(
          filterBranchesQuery(searchFilter),
        ),
    },
  );

export default userActionCreators;
